// import './i18n'

import { ThemeProvider } from './theme';
import { Router } from './router';
import { QueryProvider } from './query';
import { NuqsProvider } from './nuqs';
import { DatePickerProvider } from './date-picker';

export const Providers = () => (
  <QueryProvider>
    <NuqsProvider>
      <ThemeProvider>
        <DatePickerProvider>
          <Router />
        </DatePickerProvider>
      </ThemeProvider>
    </NuqsProvider>
  </QueryProvider>
);
